<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Survey</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>/
      <b>Survey</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>

    <div class="row mb-3">
        <div class="col-12 col-lg-6 col-sm-12">
        </div>
    </div>

    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">Survey Answer</h4>
            <div class="table-responsive">
              <table  id="payout_tbl"  class="display table table-striped table-bordered"  style="width:100%; text-align: center;">
                <thead>
                  <tr>
                      <th>No.</th>
                      <th>Survey </th>
                      <th>User </th>
                      <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(answer, index) in answers" :key="index">
                      <td width="10%">{{ index + 1 }}</td>
                      <td>{{ answer.survey_id }}</td>
                      <td>{{ answer.user_id }}</td>
                      <td width="20%">
                      <router-link :to="{name: 'view-answer', params: { id: answer.id }}" class="btn btn-primary btn-rounded btn-block">
                          View Answer
                      </router-link>
                      </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "survey-view-answer",
  components: {},

  data() {
    return {
      answers: [
        {
            id: 1,
            user_id: 4498,
            survey_id: 1,
            created_at: "2020-04-02 05:45:53",
            updated_at: "2020-04-02 05:45:53"
        },
        {
            id: 2,
            user_id: 4498,
            survey_id: 2,
            created_at: "2020-04-02 07:08:47",
            updated_at: "2020-04-02 07:08:47"
        },
      ],
    };
  },

  methods: {

  }

};
</script>


